import { render } from "./SlotSkin.vue?vue&type=template&id=3e03ef7c&scoped=true&ts=true"
import script from "./SlotSkin.vue?vue&type=script&lang=ts"
export * from "./SlotSkin.vue?vue&type=script&lang=ts"

import "./SlotSkin.vue?vue&type=style&index=0&id=3e03ef7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e03ef7c"]])

export default __exports__